import { Page } from "../../../helbest";
import { useTranslation } from "react-i18next";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useLocation } from "react-router-dom";
import styles from "./DeleteAccount.module.css";
import { Button, Input } from "antd";
import { useState } from "react";

const DeleteAccount = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [state, setState] = useState("");

  return (
    <Page
      address="/"
      show
      showFooter
      customHeader={<HeaderBack url={"/"} title={t("drawer.delete_account")} />}
      logo
      back
      footer={
        <div className={styles.pageFixedFooterContainer}>
          <Button
            data-testId="next"
            size="large"
            type="primary"
            style={{
              width: "100%",
              background: "#FF0000",
            }}
          >
            {t("common.delete")}
          </Button>
        </div>
      }
    >
      <div className={styles.deleteAccountSection}>
        <div
          className={styles.deleteAccountDescription}
          dangerouslySetInnerHTML={{ __html: t("delete_account.description") }}
        />
        <form className={styles.DeleteAccountCollapse}>
          <label className={styles.accountLable}>
            {" "}
            {t("common.first_name")}{" "}
          </label>
          <Input
            className={`${styles.accountInput} ${
              i18n.dir() === "rtl" ? "rtl-placeholder" : ""
            }`}
            type="text"
            dir={i18n.dir()}
            placeholder={t("common.first_name")}
            suffix={false}
          />

          <label className={styles.accountLable}>{t("common.last_name")}</label>
          <Input
            className={`${styles.accountInput} ${
              i18n.dir() === "rtl" ? "rtl-placeholder" : ""
            }`}
            type="text"
            dir={i18n.dir()}
            placeholder={t("common.last_name")}
            value={state}
            onChange={(e) => setState(e.target.value)}
          />
          <label className={styles.accountLable}>{t("common.email")}</label>
          <Input
            className={`${styles.accountInput} ${
              i18n.dir() === "rtl" ? "rtl-placeholder" : ""
            }`}
            type="email"
            dir={i18n.dir()}
            placeholder={t("common.email")}
          />
        </form>
      </div>
    </Page>
  );
};
export default DeleteAccount;
